import React, { memo } from "react";
import { CircleButton } from "_c/button";
import { LinkGenerator } from "@/utils/LinkGenerator";
import VkIcon from "_c/icon/Vk";
import InstaIcon from "_c/icon/Instagram";
import MessageIcon from "_c/icon/Message";
import EnvelopeIcon from "_c/icon/Envelope";
import PhoneIcon from "_c/icon/Phone";
import { analyticsAction } from "@/utils/analytics";
import { stripPhone } from "@/utils";
import type { tBizClient } from "@/types";

type tProps = {
  client: tBizClient;
};
const ClientExternalLinks = ({ client }: tProps) => {
  const onPhoneClick = () => {
    analyticsAction({
      category: "clients",
      action: "card_phone_click",
    });
  };
  const onSmsClick = () => {
    analyticsAction({
      category: "clients",
      action: "card_sms_click",
    });
  };
  const phone = stripPhone(client.phone);
  return (
    <div
      data-scroll-lock-scrollable
      css={`
        --button-size: 24px;
        display: flex;
        flex-wrap: nowrap;
        max-width: 100%;
        overflow-x: auto;
        padding-top: 10px;
        padding-bottom: 25px;
        img {
          width: var(--button-size);
          height: var(--button-size);
          min-width: var(--button-size);
          min-height: var(--button-size);
          display: block;
        }
        > * {
          margin-inline-end: 10px;
          box-shadow: none;
        }
        button,
        a {
          --size: var(--button-size);
        }
      `}
    >
      {phone && (
        <CircleButton
          onClick={onPhoneClick}
          large
          as="a"
          href={LinkGenerator.phone(client.phone)}
        >
          <PhoneIcon width="10" color="white" />
        </CircleButton>
      )}
      {phone && (
        <CircleButton
          onClick={onSmsClick}
          large
          as="a"
          href={LinkGenerator.sms(phone)}
        >
          <MessageIcon width="16" color="white" />
        </CircleButton>
      )}
      {client.insta_id && (
        <CircleButton
          large
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href={LinkGenerator.insta(client.insta_id)}
        >
          <InstaIcon color="white" width="14" />
        </CircleButton>
      )}
      {phone && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://wa.me/${phone}`}
        >
          <img src="/icons/whatsapp.svg" />
        </a>
      )}
      {phone && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`viber://chat?number=${phone}`}
        >
          <img src="/icons/viber.svg" />
        </a>
      )}
      {client.tg_id && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={LinkGenerator.tg(client.tg_id)}
        >
          <img src="/icons/telegram.svg" />
        </a>
      )}
      {client.vk_id && (
        <CircleButton
          target="_blank"
          rel="noopener noreferrer"
          large
          as="a"
          href={LinkGenerator.vk(client.vk_id)}
        >
          <VkIcon color="white" width="14" />
        </CircleButton>
      )}
      {client.email && (
        <CircleButton large as="a" href={`mailto:${client.email}`}>
          <EnvelopeIcon width="12" color="white" />
        </CircleButton>
      )}
    </div>
  );
};

export default memo(ClientExternalLinks);
